export default __webpack_public_path__ + "static/media/3.8eef6d97.png";